import { Typography, Button, Alert } from '@mui/material';

interface ErrorDisplayProps {
    title?: string;
    message: string;
    onRetry?: () => void;
    showRetry?: boolean;
}

/**
 * Error display component.
 *
 * @param {ErrorDisplayProps} props
 * @returns {JSX.Element}
 */
const ErrorDisplay: React.FC<ErrorDisplayProps> = ({ title = 'Something went wrong', message, onRetry, showRetry = false }) => {
    return (
        <>
            <Alert severity="error" sx={{ width: '100%', maxWidth: 600, boxShadow: 1 }}>
                <Typography variant="h6" gutterBottom>
                    {title}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    {message}
                </Typography>
            </Alert>
            {showRetry && onRetry && (
                <Button variant="outlined" onClick={onRetry} size="small">
                    Try again
                </Button>
            )}
        </>
    );
};

export default ErrorDisplay;
